import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Platform} from 'ionic-angular';
import 'rxjs/add/operator/toPromise';
import { LoadingController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import { NativeStorage } from '@ionic-native/native-storage';


declare var window:any;
declare var navigator:any;
declare var jQuery:any;
declare var $:any;
declare var cordova:any;
declare var localStorage:any;



@Injectable()
export class datos {
	 public url='http://vps.mangoox.net:7001/';

	 //public url='http://192.168.2.101:5000/';



	// public url='http://vps.ocrenails.com:3000/';

	 public url_soket='http://vps.mangoox.net:7001/';
	//public url_soket='http://192.168.100.223:7000/';

	 

	// public url='api/';
	socket:any;

	// public url='https://ocreapp.com/';

	//  public urlP="https://ocreapp.com/datos/";


	 // public url= 'http://186.3.185.195:8090/Precios';
public opcion="";

public resumen={
	id:0,
	desde:"",
	hasta:""
};
public consulta=0;
public solo=0;
public config={
	min_dia:90
}


// GPS-TRACK

public activo = {
	nombre:"",
	id:2,
	numero:"tel:0991609510",
	estado:"",
	clave:"123456",
	v_maxima:"",
	numero_limpio:"+593960241803",
	lat:"0",
	lng:"0",


}

public comandos = {
		desactivaPanico:"help me!",
		apagaCorriente:"stop",
		enciendeCorriente:"resume",
		activaVelocidad:"speed",
		desactivaVelocidad:"nospeed",
		modoMonitor:"monitor",
		modoTracker:"tracker",
		activaAlarmaEstacionamiento:"move",
		desactivaAlarmaEstacionamiento:"nomove",
		activaAlarmaEncendido:"arm",
		desactivaAlarmaEncendido:"disarm"


}


public pagos ={
	text:"Efectivo",
	id:1
}
solicitados =[];

public tarjetas =
	[
		{
			numero:"",
			cvs:"",
			expira:"",
			tel:"",
			perosna:""

		}
	]


public direcciones =[
	{nombre:"VEHÍCULO 1", referencia:"ROCAFUERTE AV SUCRE",lat:"", long:"", id:""},
	{nombre:"VEHÍCULO 2", referencia:"ROCAFUERTE AV SUCRE",lat:"", long:"", id:""},


];

public vehiculos =[
	{id_equipo:"",imei:"",nombre:"SIN DATOS", referencia:"ROCAFUERTE AV SUCRE",lat:"", long:"", id:""}
	


];

public login={
	user:"",
	nombre:"",
	apellido1:"",
	apellido2:"",
	pass:"",
	puntos:"",
	login:0,
	id:0

}



public parametros=
{
	usuario:"0",
	especialista:"0",
	pass:"",
	puntos:"",
	estado:""
}

public pedido ={
	pago:{text:"",id:""},
	direccion:{text:"",id:""},
	cupon:"",
	fecha:"",
	hora:"",
	usuario:"",
	total:0,
	iva:0,
	items:[
	
]
}

	Headers = new Headers();
	public certificado =true;
	public facturado=false;
	public nombre='';
	public ok =0;
	public Login=1;
	public user={
		nombre:'',
		user:'',
		id:'',
		token:''
	};

public v_load;



	constructor(
		public http: Http,
		public loadingCtrl: LoadingController,
		private toastCtrl: ToastController,
		private localNotifications: LocalNotifications,
		private nativeStorage: NativeStorage
		) {

		this.Headers.append('Content-Type', 'application/json');
		this.Headers.append('Accept', 'application/json');

	
	}



	public notificacion(text){
		this.localNotifications.schedule({
			id: 1,
			text: text,		
			data: { secret: "key" }
		  });
	}


	public addItem(item){
		let i  = this.pedido.items.indexOf(item);
		if(i > -1){
		  this.pedido.items[i].cantidad ++;
		  this.pedido.items[i].total = this.pedido.items[i].cantidad * this.pedido.items[i].valor;
		  
		 
		}
		else {
			this.pedido.items.push(item);
		}
			
	}
	public loader(a?){		
		

			if(a){
				this.v_load = this.loadingCtrl.create({
					spinner: 'bubbles',				
					content: `
					  <div class="custom-spinner-container">
						<div class="custom-spinner-box venu" > cargando ... </div>
					  </div>`
				  
				  });
				this.v_load.present();

				setTimeout(() => {
				this.v_load.dismiss();
					
				}, 2000);
			}
			else {
				this.v_load.dismiss();
			}
			
	}


	public Toast(mensaje, tiempo) {
		let toast = this.toastCtrl.create({
		  message: mensaje,
		  duration: tiempo,
		  position: 'middle',
		  cssClass:'toast'
		});

		toast.present();
	}
		


	public getPagina(ruta){
		var data = JSON.stringify(this.parametros);
		let url = this.url +ruta;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.get(url,requestOptions).map(res => res.json());

	}


	public getLogin(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getLoginEspecialistas' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}

	public getPerfil(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getPerfil' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}


	public putLlegada(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/putLlegada' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}


	public putAcepta(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/putAcepta' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}

	public putFinalizarServicio(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/putFinalizarServicio' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}


	
	public getServiciosEspecialista(p){
		var data = JSON.stringify(p);
		let url = this.url +'getServiciosEspecialista' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}

		
	public getVehiculos(){
		var data = JSON.stringify([]);
		let url = this.url +'getVehiculos' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}
	

	public ultimaUbicacion(p){
		var data = JSON.stringify(p);
		let url = this.url +'ultimaUbicacion' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}

	// public getLogin(p){
	// 	var data = JSON.stringify(p);
	// 	let url = this.url +'app/getLogin' ;
	// 	console.log(url);
	// 	let requestOptions = new RequestOptions({headers: this.Headers});
	// 	return this.http.post(url,data,requestOptions).map(res => res.json());

	// }


	public getNotificacion(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getNotificacion' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}



	public getPagos(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getPagos' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}



	public getSolicitados(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getSolicitados' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());
	}


	public getFinalizados(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getFinalizados' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}


	public getLoginEspecialistas(p){
		var data = JSON.stringify(p);
		let url = this.url +'app/getLoginEspecialistas' ;
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.post(url,data,requestOptions).map(res => res.json());

	}
	

  public getServicios(){
		var data = JSON.stringify(this.parametros);
		let url = this.url +'datos/servicios.json';
		console.log(url);
		let requestOptions = new RequestOptions({headers: this.Headers});
		return this.http.get(url,requestOptions).map(res => res.json());

	}

public reset(){
	this.pedido ={
		pago:{text:"",id:""},
		direccion:{text:"",id:""},
		cupon:"",
		fecha:"",
		hora:"",
		usuario:"",
		total:0,
		iva:0,
		items:[
		
	]
	}
}
public limpiar(dato){
let res="";

 res = JSON.stringify(dato);
 res =res.replace(/['"]+/g, '');

 res =res.replace(/[',]+/g, '/');
 res =res.replace(/['}']+/g, '');
 res =res.replace(/]/g, "");
 res =res.replace(/\[/g, "");
return res;




}

guardarDatosLocal(item){
	this.nativeStorage.setItem(item, {property: 'value', anotherProperty: 'anotherValue'})
  .then(
    () => console.log('Stored item!'),
    error => console.error('Error storing item', error)
  );


}

sacarDatosLocal(){
	this.nativeStorage.getItem('myitem')
  .then(
    data => console.log(data),
    error => console.error(error)
  );
}



conectar(){
	console.log("Conectar..."+this.url);

 this.socket = io(this.url);

   this.LoginWebSoket().subscribe(dato => {
	 console.log("login2");
		 console.log(dato);
 });

}


public LoginWebSoket() {
    console.log("login...WebSokets");
    let observable = new Observable(observer => {
      this.socket.on('connect', () => {
        // this.socket.emit('login', this.Configuracion.Area.id);

      });
    })

    return observable;

  }




  public setLocalStorage(key, value){
	// this.local.storage.(key, value);
	localStorage.setItem(key, value);

}


public getLocalStorage(key){

	return localStorage.getItem(key);
	// this.local.get(key).then((value) => {
	// 	return value;
	// 	});

}



}



// WEBPACK FOOTER //
// ./src/providers/datos.ts